import { Component, ElementRef, HostListener, Injector, OnInit } from '@angular/core';
import { TranslationService } from '../../services/translation.service';
import { ModalController, NavParams } from '@ionic/angular';
import { IBlogsUpdateRequest, NewsBlogsService } from '../../services/news-blogs.service';
import { AuthService } from 'src/app/auth/services/auth.service';
import { SettingService } from '../../services/setting.service';

@Component({
  selector: 'app-blogs',
  templateUrl: './blogs.component.html',
  styleUrls: ['./blogs.component.scss'],
  standalone: false
})
export class BlogsComponent  implements OnInit {

  
  merchantId: string;
  blog: any;
  dayData: any;

  updateBlogsRequest: IBlogsUpdateRequest;

  availableHoursString: string;

  mobile: boolean = false;

  homersLayout: boolean = false;

  constructor(
    private modalCtrl: ModalController,
    private newsBlogService: NewsBlogsService,
    public translationService: TranslationService,
    private injector: Injector,
    public authservice: AuthService,
    public settings: SettingService,
    private element: ElementRef
  ) { }

  

  ngOnInit() {
    // Only access NavParams if running inside a modal
    const navParams = this.injector.get(NavParams, null);
    try {
      if(navParams.get('blog') != undefined) {
        this.blog = navParams.get('blog');
      }
      if(navParams.get('dayData') != undefined) {
        this.dayData = navParams.get('dayData');
      }
      if(navParams.get('merchantId') != undefined) {
        this.merchantId = navParams.get('merchantId');
      }

      // double check if it works with multiple time later
      if(this.blog.dailyShowcase) {
        for(var i = 0; i < this.blog.dailyShowcase.length; i++) {
          var day = this.blog.dailyShowcase[i];
          if (day.dayID.includes(this.dayData.value)) {
            if(day.hoursRange?.startHours && day.hoursRange?.endHours) {
              if(this.availableHoursString) {
                if(this.translationService.getLanguage() == "fr") {
                  this.availableHoursString = this.availableHoursString + "De " + day.hoursRange.startHours + " a " + day.hoursRange.endHours;
                } else {
                  this.availableHoursString = this.availableHoursString + "From " + day.hoursRange.startHours + " to " + day.hoursRange.endHours;
                }
                
              } else {
                if(this.translationService.getLanguage() == "fr") {
                  this.availableHoursString = "De " + day.hoursRange.startHours + " a " + day.hoursRange.endHours;
                } else {
                  this.availableHoursString = "From " + day.hoursRange.startHours + " to " + day.hoursRange.endHours;
                }
                
              }
            }
            
          }
        }
      }
      

      /*
      console.log(this.blog.dailyShowcase);

      console.log(this.blog);
      console.log(this.dayData);
      */
    } catch (e) {
      //console.log(e);

      this.closePopup();
    }

    const hostElement = this.element.nativeElement;
    const host = hostElement;
    host.style.setProperty('--btn-color', this.blog.btnColor);
    host.style.setProperty('--btn-txt-color', this.blog.btnTextColor);

    if (window.innerWidth <= 500) {
      this.mobile = true; 
    } else {
      this.mobile = false;
    }

    if(this.settings.configuration.uIoptions && this.settings.configuration.homePageConfiguration != null && this.settings.configuration.uIoptions?.homePageOption == 10) {
      this.homersLayout = true;
    } else {
      this.homersLayout = false;
    }
  }

  @HostListener('window:resize', ['$event'])  
  onResize(event) { 
    if (window.innerWidth <= 500) { 
      this.mobile = true;
    } else {
      this.mobile = false;
    }
  }

  UseLink() {
    // use the link that is in 
    //this.blog.btnLink.translations[this.translationService.getLanguage()]
  }

  getblogsImage(){
    //smaImage
    if (this.blog.images.imgShortName == null && this.blog.images.imgDisplayName) {
      const urlPath = this.blog.images.imgDisplayName;
      return "https://seemyapps.com" + urlPath;
    } else {
      //SMS image
      if(this.blog.images){
        if(this.blog.images.imgURL) {
          const url = this.blog.images.imgURL;
          return url;
        }     
      }
    }
  }

  textDisplay(text, lang) {
    const fallbackLang = lang === 'en' ? 'fr' : 'en';

    return text.translations[lang] ?? text.translations[fallbackLang];
  }

  formatDate(date: any): string {

    if (!date) {
      return '';
    }

    if (typeof date === 'string') {
      return date.split('T')[0];
    }

    return new Date(date).toISOString().split('T')[0];
  }

  deleteblogs() {
    // delete the specified blog passing through
    this.deleteBlog(this.blog).subscribe(async completedDeletion => {
      if(completedDeletion) {
        this.modalCtrl.dismiss("deleted");
      }
    });
  }

  deleteBlog(blog) {
    this.updateBlogsRequest = {
      merchantId: this.merchantId,
      userId: this.authservice.memberId.toString(),
      blogId: blog.id,
      status: "deleted"
    }

    return this.newsBlogService.updateBlogs(this.updateBlogsRequest);
  }

  



  closePopup(){
    //if(this.isPopup) {
      this.modalCtrl.dismiss();
    //}
  }
}
